import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1348634a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "containerOnboarding"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "1. Apri l'app Impostazioni sul tuo dispositivo Android.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "2. Scorri verso il basso e seleziona \"Posizione\" o \"Localizzazione\".", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "3. Assicurati che l'interruttore di posizione sia attivato.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "4. Torna alla schermata principale delle impostaizoni", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "5. Scorri verso il basso e seleziona \"Applicazioni/App\".", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "6. Scorri verso il basso e seleziona \"Gestione applicazioni\".", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "7. Scorri verso il basso e seleziona \"Google Chrome\".", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "8. Seleziona \"Autorizzazioni\"", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "9. Seleziona \"Posizione\"", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "10. Assicurati che sia selezionato l'interruttore \"Consenti solo mentre l'app è in uso\" (come da immagine)", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "11. Assicurati che sia abilitato l'interruttore \"Usa posizione esatta\" (come da immagine)", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "12. Assicurati che il tuo browser Google Chrome sia aggiornato all'ultima versione disponibile.", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "1. Apri l'app Impostazioni sul tuo dispositivo iOS.", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "2. Scorri verso il basso e tocca \"Privacy e sicurezza\".", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "3. Tocca \"Localizzazione\".", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "4. Assicurati che l'opzione \"Localizzazione\" sia attivata.", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "5. Scorri verso il basso e trova \"Siti web di Safari\".", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "6. Seleziona \"Mentre usi l'app\" per consentire ai siti web di accedere alla tua posizione. (come da immagine)", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "7. Assicurati che l'opzione \"Posizione esatta\" sia attivata. (come da immagine)", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "messageOnboarding" }, "8. Assicurati che il tuo browser Safari sia aggiornato all'ultima versione disponibile.", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Attenzione", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "message" }, "Per poter procedere bisogna accettare i permessi della fotocamera.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_CameraScanner = _resolveComponent("CameraScanner")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, {
                class: "title",
                style: {"font-weight":"bold"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Esse group ")
                ]),
                _: 1
              }),
              _hoisted_1,
              _createVNode(_component_ion_label, { class: "version" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.appVersion), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, { onClick: _ctx.onHelpClick }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.helpCircleSharp,
                        size: "large"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_button, { onClick: _ctx.onLogoutClick }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.logOut,
                        size: "large"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: _normalizeClass(_ctx.className)
      }, {
        default: _withCtx(() => [
          (_ctx.cameraEnable)
            ? (_openBlock(), _createBlock(_component_CameraScanner, {
                key: 0,
                onDecodeQrCode: _ctx.decodeQRCode,
                onCameraIsEnable: _ctx.cameraIsEnable
              }, null, 8, ["onDecodeQrCode", "onCameraIsEnable"]))
            : _createCommentVNode("", true),
          (_ctx.isOnboarding)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.switchOnboardingStatus == 'android')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _hoisted_5,
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11,
                      _hoisted_12,
                      _hoisted_13,
                      _hoisted_14,
                      _hoisted_15,
                      _createVNode(_component_ion_img, {
                        class: "imageOnboarding",
                        src: _ctx.onboardingAndroid
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.switchOnboardingStatus == 'ios')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _createVNode(_component_ion_img, {
                        class: "imageOnboarding",
                        src: _ctx.onboardingIos
                      }, null, 8, ["src"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_button, {
                  class: "btnOnboarding",
                  color: "primary",
                  expand: "block",
                  onClick: _ctx.onCloseOnBoarding
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Fatto")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : (!_ctx.isEnabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _hoisted_25,
                  _hoisted_26,
                  _createVNode(_component_ion_button, {
                    class: "btn",
                    color: "primary",
                    onClick: _ctx.onRequireCameraPermissions
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Richiedi permesso")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _: 1
  }))
}